const SALES_PRODUCT_TIPOS = new Set([33, 39, 41]);

function resolveDetalleItems(item) {
  if (!item || typeof item !== "object") return [];
  if (Array.isArray(item.detalle_items) && item.detalle_items.length > 0) {
    return item.detalle_items;
  }
  const pn = item.payload_normalized;
  if (pn && typeof pn === "object") {
    const candidates = [
      pn.detalle,
      pn.detalle_items,
      pn.items,
      pn.factura?.detalle,
      pn.boleta?.detalle,
      pn.notaCredito?.detalle,
      pn.notaDebito?.detalle,
      pn.guiaDespacho?.detalle,
    ];
    for (const candidate of candidates) {
      if (Array.isArray(candidate) && candidate.length > 0) return candidate;
    }
  }
  const po = item.payload_original;
  if (po && typeof po === "object") {
    const candidates = [
      po.items,
      po.detalle,
      po.detalle_items,
      po.factura?.detalle,
      po.invoice?.items,
      po.invoice?.detalle,
      po.boleta?.detalle,
      po.notaCredito?.detalle,
      po.notaDebito?.detalle,
      po.guiaDespacho?.detalle,
    ];
    for (const candidate of candidates) {
      if (Array.isArray(candidate) && candidate.length > 0) return candidate;
    }
  }
  return [];
}

function detailLineName(line) {
  return String(
    line?.NmbItem ??
      line?.nombre ??
      line?.name ??
      line?.nombreItem ??
      line?.descripcion ??
      "Producto sin nombre",
  ).trim();
}

function detailLineSku(line) {
  if (!line || typeof line !== "object") return "";
  const cdgItem = line.CdgItem ?? line.cdgItem;
  if (Array.isArray(cdgItem) && cdgItem.length > 0) {
    const first = cdgItem[0];
    const raw =
      first?.VlrCodigo ?? first?.vlrCodigo ?? first?.valor ?? first?.codigo ?? "";
    return String(raw || "").trim();
  }
  if (cdgItem && typeof cdgItem === "object") {
    const raw =
      cdgItem.VlrCodigo ?? cdgItem.vlrCodigo ?? cdgItem.valor ?? cdgItem.codigo ?? "";
    return String(raw || "").trim();
  }
  return String(line.sku ?? line.codigo ?? line.code ?? "").trim();
}

function detailLineQty(line) {
  const qty = Number(line?.QtyItem ?? line?.qtyItem ?? line?.cantidad ?? line?.qty ?? 0);
  return Number.isFinite(qty) ? qty : 0;
}

function detailLineAmount(line) {
  const direct = Number(
    line?.MontoItem ??
      line?.montoItem ??
      line?.monto ??
      line?.subtotal ??
      line?.amount
  );
  if (Number.isFinite(direct)) return direct;
  const qty = detailLineQty(line);
  const price = Number(
    line?.PrcItem ??
      line?.prcItem ??
      line?.precioUnitario ??
      line?.precio ??
      line?.unitPrice ??
      0
  );
  if (!Number.isFinite(price)) return 0;
  const gross = qty * price;
  const discountPct = Number(line?.DescuentoPct ?? line?.discountPct ?? 0);
  const discountAmount = Number(
    line?.DescuentoMonto ?? line?.discountAmount ?? 0
  );
  if (Number.isFinite(discountAmount) && discountAmount > 0) {
    return gross - discountAmount;
  }
  if (Number.isFinite(discountPct) && discountPct > 0) {
    return gross - gross * (discountPct / 100);
  }
  return gross;
}

export function truncateProductName(value, maxLen = 42) {
  const text = String(value || "").trim();
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen)}…`;
}

export function buildTopProducts(rows = []) {
  const map = new Map();
  for (const row of rows) {
    if (!SALES_PRODUCT_TIPOS.has(Number(row?.tipo_dte || 0))) continue;
    for (const line of resolveDetalleItems(row)) {
      const name = detailLineName(line);
      if (!name) continue;
      const sku = detailLineSku(line);
      const key = sku || name;
      const current = map.get(key) || {
        sku,
        name,
        units: 0,
        amount: 0,
        orders: 0,
        avgTicket: 0,
      };
      current.units += detailLineQty(line);
      current.amount += detailLineAmount(line);
      current.orders += 1;
      if (!current.sku && sku) current.sku = sku;
      map.set(key, current);
    }
  }
  return Array.from(map.values()).map((row) => ({
    ...row,
    avgTicket: row.orders > 0 ? row.amount / row.orders : 0,
  }));
}

export function sortTopProducts(rows = [], sortBy = "units") {
  const items = [...rows];
  if (sortBy === "amount") {
    return items.sort((a, b) => {
      if (b.amount !== a.amount) return b.amount - a.amount;
      return b.units - a.units;
    });
  }
  return items.sort((a, b) => {
    if (b.units !== a.units) return b.units - a.units;
    return b.amount - a.amount;
  });
}

export const TOP_PRODUCTS_SORT_OPTIONS = [
  { value: "units", label: "Más vendidos" },
  { value: "amount", label: "Mayor facturación" },
];
